import ArticlesTabContentManagementPanel from "@/components/discovery/discovery-content-control-panels/ArticlesTabContentManagementPanel";
import FeedArticlesTable from "@/components/discovery/feed-articles-table/FeedArticlesTable";

/**
 * Articles tab content for Discovery (nav v2).
 * Renders the content management panel and articles table.
 * Wrapper is flex column so the table (flex-1 min-h-0) gets height inside TabPanel.
 */
const ArticlesTab = () => (
  <div className="flex min-h-0 flex-1 flex-col">
    <ArticlesTabContentManagementPanel />
    <div className="min-h-0 flex-1">
      <FeedArticlesTable />
    </div>
  </div>
);

export default ArticlesTab;
